import React from 'react';

const TagIndicatorFilterHeaderCell = () => (
  <th style={{ visibility: 'hidden' }}>
    <div />
  </th>
);

export default TagIndicatorFilterHeaderCell;



// WEBPACK FOOTER //
// ./src/components/Tables/TagIndicatorFilterHeaderCell.js